import React from 'react';
import { Route, Redirect } from 'react-router-dom';

// FAIL-OPEN subscription gate. Blocks ONLY on positive proof that the account
// both requires a subscription AND lacks a good one. Existing salons never
// carry requiresSubscription, so they are never gated. ANY uncertainty — feed
// not yet loaded, parse error, missing fields — lets the user straight through.
// The feed lives in localStorage 'subscriptionGate', refreshed on every app
// boot (routes.js) from GET /v2/user/subscriptionStatus.
function isSubscriptionBlocked() {
    try {
        const raw = localStorage.getItem('subscriptionGate');
        if (!raw) return false;                                  // no feed → allow
        const g = JSON.parse(raw);
        if (!g || g.requiresSubscription !== true) return false; // unflagged → allow
        const ok = g.subscriptionStatus === 'trialing' || g.subscriptionStatus === 'active';
        return !ok;                                              // flagged + not good → block
    } catch (e) {
        return false;                                            // any error → allow
    }
}

// FAIL-OPEN Partner Terms gate for self-employed professionals. Blocks ONLY
// on positive proof from the server that this account must accept the current
// Partner Terms version and hasn't. Feed lives in localStorage
// 'partnerTermsGate', refreshed on every app boot (routes.js) from
// GET /v2/policy/partner_terms/status, and cleared the moment they accept.
// Any uncertainty (no feed, parse error, missing field) lets them through —
// this must never lock a working stylist out of their diary on a bad network.
function isPartnerTermsBlocked() {
    try {
        const raw = localStorage.getItem('partnerTermsGate');
        if (!raw) return false;
        const g = JSON.parse(raw);
        return !!(g && g.requiresAcceptance === true);
    } catch (e) {
        return false;
    }
}

export const PrivateRoute = ({ component: Component, ...rest }) => (

    <Route {...rest} render={props => {
        if (!localStorage.getItem('accessToken')) {
            return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
        }
        if (isSubscriptionBlocked()) {
            return <Redirect to="/subscription-checkout" />;
        }
        // Remember where they were heading so the welcome page can return
        // them there once they've accepted.
        if (isPartnerTermsBlocked()) {
            return <Redirect to={{ pathname: '/welcome/partner-terms', state: { from: props.location } }} />;
        }
        return <Component {...props} />;
    }} />
)
